import { render } from "./check-card.vue?vue&type=template&id=e71c561c"
import script from "./check-card.vue?vue&type=script&lang=js"
export * from "./check-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__